











































import { defineComponent, PropType } from '@vue/composition-api';
import type { RunCourseRow, ReportRouteSlim, RoutePosition, ContextMenuMode } from '@/models/runCourse';
import RouteItem from './RouteItem.vue';
import { dtFormat } from '@/lib/dateHelper';

export default defineComponent({
  components: {
    RouteItem,
  },
  props: {
    row: {
      type: Object as PropType<RunCourseRow>,
      required: true,
    },
    sheetIdx: {
      type: Number,
      required: true,
    },
    rowIdx: {
      type: Number,
      required: true,
    },
  },
  emits: ['create', 'edit', 'show-contextmenu', 'update-bikou', 'blur'],
  setup(props, { emit }) {
    const onCreate = (params: RoutePosition) => {
      emit('create', params);
    };

    const onEdit = (route: ReportRouteSlim, params: RoutePosition) => {
      emit('edit', route, params);
    };

    const onShowContextmenu = (event: MouseEvent, params: RoutePosition, mode: ContextMenuMode) => {
      emit('show-contextmenu', event, params, mode);
    };

    const onUpdateBikou = (event: Event) => {
      emit('update-bikou', props.sheetIdx, props.rowIdx, (event.target as HTMLTextAreaElement).value);
    };

    return {
      onCreate,
      onEdit,
      onShowContextmenu,
      onUpdateBikou,
      dtFormat,
    };
  },
});
